import {createSlice} from "@reduxjs/toolkit";
import {PaymentInterface, Forma} from "@/interfaces/PaymentInterface";
import Apm from "@/utils/Apm";
import Nullable from "@/types/utils/Nullable";
import State from "@/types/utils/State";

interface IPaymentData{
    documento: string
    agencia?: string
    digito?: string
    banco?: string
    agencia_digito?: string
    nonce?: string
    numero?: Nullable<string>
    validade?: Nullable<string>
    titular?: Nullable<string>
    cvv?: Nullable<string>
    parcela?:string
}

export type Payment = IPaymentData | string

const initialState: State<PaymentInterface> = {
    value: {
        idPedido: 0,
        documento:'',
        debito: {
            agencia: undefined,
            agencia_digito: undefined,
            banco: undefined,
            digito: undefined,
            numero: undefined
        },
        paypal: {
            nonce: undefined
        },
        valor: null,
        forma: "cc",
        cartao: {
            numero: null,
            validade: null,
            cvv: null,
            titular: null
        },
        parcela:undefined,
        voucher:undefined,
    }
}

export const paymentSlice = createSlice({
    name: "payment",
    initialState,
    reducers: {
        SET_PAYMENT_ID_PEDIDO: (state, action: {payload: Nullable<number>}) => {
            const {payload} = action
            state.value.idPedido = payload
        },
        SET_PAYMENT_METHOD: (state, action: {payload: Forma}) => {
            const {payload} = action
            state.value.forma = payload
        },
        SET_OFFER_VALUE: (state, action: {payload: Nullable<number>}) => {
            const {payload} = action
            state.value.valor = payload
        },
        SET_PAYMENT_DATA: (state, action: {payload: Payment}) => {
            const {payload} = action
            switch (state.value.forma) {
                case 'dc':
                    if(typeof payload === 'string'){
                        Apm.captureError('Erro no arquivo store/slices/paymentSlice.ts payload não era do tipo string')
                        break
                    }

                    if(payload.agencia && payload.numero && payload.digito && payload.agencia_digito){
                        state.value.debito.agencia = payload.agencia;
                        state.value.debito.numero = payload.numero;
                        state.value.debito.digito = payload.digito;
                        state.value.debito.agencia_digito = payload.agencia_digito;
                        state.value.documento = payload.documento
                    }else{
                        Apm.captureError('Erro no arquivo store/slices/paymentSlice.ts payload faltando dados para pagamento')
                    }
                    break;
                case 'paypal':
                    if(typeof payload === 'string'){
                        Apm.captureError('Erro no arquivo store/slices/paymentSlice.ts payload não era do tipo string')
                        break
                    }

                    if(!payload.nonce){
                        Apm.captureError('Erro no arquivo store/slices/paymentSlice.ts payload faltando propriedade nonce')
                        break
                    }

                    state.value.paypal.nonce = payload.nonce.toString()
                    state.value.documento = payload.documento
                    break;
                case 'cc':
                    if(typeof payload === 'string'){
                        Apm.captureError('Erro no arquivo store/slices/paymentSlice.ts payload não era do tipo string')
                        break
                    }

                    if(payload.numero && payload.cvv && payload.titular && payload.validade){
                        state.value.cartao.numero = payload.numero;
                        state.value.cartao.cvv = payload.cvv;
                        state.value.cartao.titular = payload.titular;
                        state.value.cartao.validade = payload.validade
                        state.value.documento = payload.documento
                        if(payload.parcela){
                            state.value.parcela = payload.parcela
                        }
                    }
                    break;
                case 'pre-pago':
                    if(typeof payload === 'string'){
                        state.value.voucher = payload;
                    }else{
                        Apm.captureError('Erro no arquivo store/slices/paymentSlice.ts payload não era do tipo string')
                    }
                    break;
            }
        }
    }
})

export const {SET_PAYMENT_METHOD} = paymentSlice.actions
export const {SET_PAYMENT_DATA} = paymentSlice.actions
export const {SET_PAYMENT_ID_PEDIDO} = paymentSlice.actions
export const GET_PAYMENT_DATA = (state: any): PaymentInterface => state.payment.value
export const GET_PAYMENT_METHOD = (state: any): Forma => state.payment.value.forma
export default paymentSlice.reducer